export default "__VITE_PUBLIC_ASSET__c17cd786__"